import classNames from 'classnames'
import { useCurrentUser } from '../../../modules/context/UserContext'
import { n_pricing, s_pricing } from '../../../modules/i18n/strings/auto/wording'
import useTranslation, { useLocaleVars } from '../../../modules/i18n/useTranslation'
import { add24Hours, isWithIn24HoursUser } from '../../../modules/utils'
import { COUNTRY_ALPHA2_CODE } from '../../../modules/vars'
import { D_DAY_TYPE, DdayCounter } from '../../common/DdayCounter'
import { PRICING_TAB } from './PricingBodyWeb.util'
import PricingSwitchCurrency from './PricingSwitchCurrency'

const PricingDurationSelectSection = ({ duration, setDuration, setCountryCode, countryCode, activeId }) => {
  const vars = useLocaleVars()
  const { duration_list } = vars
  const isTwentyActive = duration_list[0]?.value == duration.value
  const { t } = useTranslation()
  const { currentUser } = useCurrentUser()
  const isShowPricingCounterBanner = !currentUser || (currentUser && isWithIn24HoursUser(currentUser))

  return (
    <div className="">
      <div className="mt-[48px]">
        <div className="flex flex-col sm:flex-row px-[16px] sm:px-[0px]">
          <span className="text-gray-700 Title1-20Bd mr-[16px]">{t(n_pricing.select_package.title)}</span>
          {isShowPricingCounterBanner && (
            <div className="flex mt-[16px] sm:mt-[0px]">
              <div className="flex flex-row items-center rounded-[4px] bg-red-500 border-1 border-red-200 px-[6px]">
                <img
                  className="w-[16px] h-[16px] mr-[2px]"
                  src={'https://d38emex6h5e12i.cloudfront.net/2024-image/1718696404162_clock_bg_white_red.webp'}
                  alt="red_clock"
                />
                <div className="mr-[4px] pt-[1px]">
                  <DdayCounter
                    initialDay={new Date()}
                    targetDay={
                      new Date(
                        currentUser ? add24Hours(currentUser?.braze?.private?.signup_date) : add24Hours(new Date())
                      )
                    }
                    types={[D_DAY_TYPE.HOUR, D_DAY_TYPE.MIN, D_DAY_TYPE.SEC]}
                    classNameTotalContainer="flex flex-row items-center mb-[0px]"
                    classNameDigitContainer={classNames(
                      'text-white Body2-14Bd mt-[1px] flex flex-row items-center justify-center gap-x-[0px]'
                    )}
                    seperator={
                      <div
                        className={classNames(
                          'text-white Body2-14Bd justify-center mb-[1px] flex flex-col items-center'
                        )}
                      >
                        :
                      </div>
                    }
                  />
                </div>
                {/* <span className="text-white Body2-14Bd pt-[1px]">{t(n_pricing.label.first_buy_timer(''))}</span> */}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="relative flex flex-col sm:flex-row sm:items-center justify-between mt-[17px] px-[16px] sm:px-[0px]">
        <div className="flex gap-[2px] rounded-[5px] bg-gray-100 p-[2px] sm:w-auto sm:max-w-[336px] w-full">
          <button
            className={classNames(
              'Body1-16Bd w-full rounded-[5px] px-[8px] py-[6px] text-center sm:w-auto sm:min-w-[150px] whitespace-nowrap',
              {
                'bg-white shadow-[0px_1px_4px_0px_rgba(0,0,0,0.15)] text-black': isTwentyActive,
                'bg-gray-100 text-gray-400': !isTwentyActive,
              }
            )}
            onClick={() => setDuration(duration_list[0])}
          >
            {t(n_pricing.min_20)}
          </button>
          <button
            className={classNames(
              'Body1-16Bd w-full rounded-[5px] px-[8px] py-[6px] text-center sm:min-w-[150px] whitespace-nowrap',
              {
                'bg-white shadow-[0px_1px_4px_0px_rgba(0,0,0,0.15)] text-black': !isTwentyActive,
                'bg-gray-100 text-gray-400': isTwentyActive,
              }
            )}
            onClick={() => setDuration(duration_list[1])}
          >
            {t(n_pricing.min_40)}
          </button>
        </div>
        <div className="mt-[16px] max-w-[90px]">
          <PricingSwitchCurrency />
        </div>
        {activeId == PRICING_TAB.EVERY_WEEK && (
          <div className="flex sm:hidden Body2-14Md keep-all flex-col text-gray-600 justify-start mt-[16px]">
            <span className="">*{t(n_pricing.notice_every_week)}</span>
            <span className="">*{t(n_pricing.notice_common)}</span>
            {countryCode != COUNTRY_ALPHA2_CODE.KR && (
              <div className="flex sm:hidden keep-all flex-col text-gray-600">
                <div className="">*{t(s_pricing.notice_usd)}</div>
                <div className="">*{t(s_pricing.notice_exchange)}</div>
              </div>
            )}
          </div>
        )}
        {activeId == PRICING_TAB.FLEXIBLE && (
          <div className="flex sm:hidden Body2-14Md keep-all flex-col text-gray-600 mt-[16px]">
            <span className="">*{t(n_pricing.notice_common)}</span>
            {countryCode != COUNTRY_ALPHA2_CODE.KR && (
              <div className="flex sm:hidden keep-all flex-col text-gray-600">
                <div className="">*{t(s_pricing.notice_usd)}</div>
                <div className="">*{t(s_pricing.notice_exchange)}</div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default PricingDurationSelectSection

export const PricingB2BSelectSection = ({ duration, setDuration }) => {
  const vars = useLocaleVars()
  const { duration_list } = vars
  const isTwentyActive = duration_list[0]?.value == duration.value
  const { t } = useTranslation()
  return (
    <div className="smd:px-[16px] flex w-full justify-center">
      <div className="flex w-full gap-[2px] rounded-[5px] bg-gray-100 p-[2px] sm:w-auto sm:max-w-[336px]">
        <button
          className={classNames(
            'Body1-16Bd w-full rounded-[5px] px-[8px] py-[6px] text-center sm:w-auto sm:min-w-[150px]',
            {
              'bg-white shadow-[0px_1px_4px_0px_rgba(0,0,0,0.15)] text-black': isTwentyActive,
              'bg-gray-100 text-gray-400': !isTwentyActive,
            }
          )}
          onClick={() => setDuration(duration_list[0])}
        >
          {t(n_pricing.min_20)}
        </button>
        <button
          className={classNames('Body1-16Bd w-full rounded-[5px] px-[8px] py-[6px] text-center sm:min-w-[150px]', {
            'bg-white shadow-[0px_1px_4px_0px_rgba(0,0,0,0.15)] text-black': !isTwentyActive,
            'bg-gray-100 text-gray-400': isTwentyActive,
          })}
          onClick={() => setDuration(duration_list[1])}
        >
          {t(n_pricing.min_40)}
        </button>
      </div>
    </div>
  )
}
